export const GALLERY_PREVIEW_IMAGE_COUNT = 5;
export const DEFAULT_IMAGE_OFFSET = 1;
export const SMALL_IMAGE_OFFSET = 2;
